import { TabsNavigation } from '@wajeez-web/components/ui';
import { useState } from 'react';
import { IconType } from 'react-icons';
// import { PageLayoutsContainerProps } from "../../constants/types/componentsTypes/InnerpageTypes";
// import InnerPageSkeleton from "../../components/DataDisplay/ComponentsSkeletons/InnerPageSkeleton";
// import TabsNavigation from "../../components/Navigation/TabsNavigation";
import PageHeader from '../Headers/PageHeader';
import InnerPageSkeleton from '../Skeletons/InnerPageSkeleton';
import { PageHeaderEndSideComponentType } from './PageLayoutsContainer';

export interface PageLayoutsContainerProps {
  title: string | JSX.Element;
  endSideComponent?: PageHeaderEndSideComponentType[];
  breadCrumbsLinks?: { title: string; link?: string }[];
  content?: JSX.Element[];
  children: JSX.Element;
  tabs: TabsProps[];
  selectedTabChangeAction?: (index: number) => void;
  maxWidth?: 'XL' | 'LG' | 'MD' | 'SM';
  isLoading?: boolean;
}

export interface TabsProps {
  text: string;
  disabled: boolean;
  desc?: string;
  Icon?: IconType;
  key?: string;
  href?: string;
  subTabs?: { text: string; id?: number | string; href: string }[];
}

const PageLayoutsContainerWithTabs = ({
  title,
  endSideComponent,
  breadCrumbsLinks,
  children,
  tabs,
  isLoading,
}: PageLayoutsContainerProps) => {
  const [selectedTab, setSelectedTab] = useState(0);

  return isLoading ? (
    <InnerPageSkeleton
      title={title}
      breadCrumbsLinks={breadCrumbsLinks || []}
    />
  ) : (
    <div className="flex overflow-hidden h-inner-screen  ">
      {tabs && tabs.length > 0 && (
        <TabsNavigation
          tabs={tabs}
          selectedTab={selectedTab}
          setSelectedTab={(selected) => setSelectedTab(selected)}
        />
      )}

      <div className="flex-grow overflow-y-auto  overflow-x-hidden">
        <PageHeader
          title={title}
          endSideComponent={endSideComponent}
          breadCrumbsLinks={breadCrumbsLinks}
          hasToggleButton={tabs.length > 0}
        />
        <div className={`py-4 w-full md:px-8 px-4   h-full    `}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageLayoutsContainerWithTabs;
